import { useContext } from 'react';
import { ActionRequiredInvoicesContext } from 'src/sections/action_required_invoices/ActionRequiredInvoicesContext';

const useActionRequiredInvoices = () => {
  const context = useContext(ActionRequiredInvoicesContext);
  if (!context)
    throw new Error('Action required context must be used inside ActionRequiredProvider');
  return context;
};

export default useActionRequiredInvoices;
